import { render, staticRenderFns } from "./assetManagement.vue?vue&type=template&id=6abb84ba&scoped=true&"
import script from "./assetManagement.vue?vue&type=script&lang=js&"
export * from "./assetManagement.vue?vue&type=script&lang=js&"
import style0 from "./assetManagement.vue?vue&type=style&index=0&id=6abb84ba&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6abb84ba",
  null
  
)

export default component.exports